import React from "react";
import ServiceTipsCard from "./serviceTips-Card";

const ServiceTips = () => {
  return (
    <div className="row">
        <ServiceTipsCard id={"01"} caption={"IT Consultancy"} detail={"Professional advice on technology-related matters for businesses/individuals."} />
        
        <ServiceTipsCard id={"02"} caption={"Enterprise Software Development"} detail={"Technology-based services to establish/maintain an online presence."} />
        
        <ServiceTipsCard id={"03"} caption={"Web Hosting"} detail={"Promptly addressing customer concerns and ensuring satisfaction."} />

        <ServiceTipsCard id={"04"} caption={"Tech Training"} detail={"High-level knowledge for customized and effective business solutions."} />
    </div>
  );
};

export default ServiceTips;